import { AidaPayload } from '../interfaces/aida.interface';

export const DEFAULT = Object.freeze({
  AIDA_PAYLOAD: <AidaPayload>{
    enabled: false,
  },
  NESTED_GROUP_KEY: 'Nested',
  QBP: { enable: false },
});
